import { render } from "./PhotoPage.vue?vue&type=template&id=baae2c52&scoped=true"
import script from "./PhotoPage.vue?vue&type=script&lang=js"
export * from "./PhotoPage.vue?vue&type=script&lang=js"

import "./PhotoPage.vue?vue&type=style&index=0&id=baae2c52&scoped=true&lang=css"

import exportComponent from "/Users/yalemarc/Documents/yaleapps/simplify-photo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-baae2c52"]])

export default __exports__